var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.5H17V22.5C17 23.05 16.55 23.5 16 23.5C15.45 23.5 15 23.05 15 22.5V17.5H10C9.45 17.5 9 17.05 9 16.5C9 15.95 9.45 15.5 10 15.5H15V10.5C15 9.95 15.45 9.5 16 9.5C16.55 9.5 17 9.95 17 10.5V15.5H22C22.55 15.5 23 15.95 23 16.5C23 17.05 22.55 17.5 22 17.5Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add-item.9d25c3ffd6b32b552f989dd179f5a1cb.svg";
export { ForwardRef as ReactComponent };